export enum Clients {
  A5 = "a5",
  A6 = "a6",
  ADMIN_QUANTILIA = "admin-quantilia",
  C3 = "c3",
  C5 = "c5",
  C7 = "c7",
  D1 = "d1",
  E2 = "e2",
  E3 = "e3",
  ETL_QUANTILIA = "etl-quantilia",
  F1 = "f1",
  F1_QUANTILIA = "f1-quantilia", // FIXME: is this client relevant ?
  G4 = "g4",
  I1 = "i1",
  L1 = "l1",
  M2 = "m2",
  N1 = "n1",
  QTL = "etl-quantilia",
  QTL_REFERENTIAL = "qtl - referential",
  QTL_USERS = "qtl - users",
  S1 = "s1",
  S1_FO = "s1-fo",
  S1_QUANTILIA = "s1-quantilia",
  S3 = "s3",
  S2 = "s2",
}
